import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { CoreUiRoutePath } from "./configs/_coreui.route-path";
import coreuiRoutes from "./configs/_coreui.routes";
import CoreUiAppLayout from "./features/layout/CoreUiAppLayout";
import Login from "./features/pages/login/Login";
import Register from "./features/pages/register/Register";
import Page404 from "./features/pages/page404/Page404";
import Page500 from "./features/pages/page500/Page500";
import EmailApp from "./features/apps/email/EmailApp";
import { useCoreUiThemeSwitcher } from "./features/layout/controllers/useCoreUiThemeSwitcher";
const CoreUiDashboard = React.lazy(
  () => import("./features/dashboard/CoreUiDashboard"),
);

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const AppCoreUi = () => {
  const {
    state: { theme: _theme },
  } = useCoreUiThemeSwitcher();
  return (
    // <div className={_theme !== "dark" ? "cms-light" : "cms-dark"}>
    <Suspense fallback={loading}>
      <Routes>
        <Route path={CoreUiRoutePath.Home} element={<CoreUiAppLayout />}>
          {coreuiRoutes.map((route, idx) => {
            return (
              route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  element={<route.component />}
                />
              )
            );
          })}
          <Route
            path={CoreUiRoutePath.Dashboard}
            element={<CoreUiDashboard />}
          />
          <Route
            path="*"
            element={<Navigate to={CoreUiRoutePath.Dashboard} replace />}
          />
        </Route>
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="404" element={<Page404 />} />
        <Route path="500" element={<Page500 />} />

        <Route path="apps/email/*" element={<EmailApp />} />
      </Routes>
    </Suspense>
    // </div>
  );
};
export default AppCoreUi;
